import type { FaqItem } from "@/types/content";

export const faqs: FaqItem[] = [
  {
    q: "瓜线上的事件时间线是怎么整理的？",
    a: "编辑会先梳理公开报道与各方声明，把可核实的关键节点按时间排序，再标注每个节点属于「预热、反转、回应」还是「收尾」，让情节推进一眼可见。无法确认来源的说法会被明确标注为「待求证」。",
  },
  {
    q: "为什么有些事件里人物只用代称？",
    a: "对于尚未有官方回应、且涉及个人名誉的传闻，我们会用代称或模糊描述，避免把未经证实的指控与具体个人直接绑定。等事件有明确结论后，才会补充更完整的背景说明。",
  },
  {
    q: "事件页面会更新吗？后续有新进展怎么办？",
    a: "会。每个事件页都标注了最近更新时间。有实质性新进展时，我们会在原时间线末尾追加节点，而不是直接改写旧内容，方便你对照前后变化。",
  },
  {
    q: "如果想追某个特定领域的热点，有快捷入口吗？",
    a: "有的。事件库页面支持按主题分类筛选，也支持关键词搜索。比如想只看直播电商相关的事件，进入事件库后选择对应分类即可。",
  },
  {
    q: "可以投稿或者指出内容里的错误吗？",
    a: "非常欢迎。在「关于我们」页面底部有投稿与联系表单，把链接、截图或你的疑问写清楚，我们会尽快核对。内容纠错对我们来说和内容生产同样重要。",
  },
  {
    q: "瓜线的资料可以转载引用吗？",
    a: "站内原创的时间线梳理与复盘文字，欢迎在注明来源并附上原文链接的前提下引用。若引用带有「待求证」标注的内容，请一并保留该标注，避免误导他人。",
  },
];